import styled from 'styled-components/native'

export const SearchResultContainer = styled.View`
  padding: 5px;
  height: 55px;
`

export const ResultNameHolder = styled.Text`
  font-weight: 600;
  font-size: 16px;
`

export const ResultAdditionalContent = styled.Text`
  font-size: 12px;
`
